import React from 'react';

interface DataMethodLinkpProps {
  onClick?: () => void;
}

const DataMethodLink = (props: DataMethodLinkpProps) => {
  const handleOpen = () => {
    window.document.body.style.top = `-${window.scrollY}px`;
    window.document.body.classList.add('dataMethodologyPopup-open');
    var popup = document.querySelector('.dataMethodologyPopup');
    var backdrop = document.querySelector('.dataMethodologyPopup-backdrop');

    if (backdrop) {
      backdrop.style.display = 'block';
    }
    if (popup) {
      popup.style.display = 'block';
    }

    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <a href="javascript:void(0);" onClick={handleOpen}>
      Daten & Methode
    </a>
  );
};

export default DataMethodLink;
